angular.module('rentalListingModule').component('rentalListingAdd', {
	templateUrl: 'rentalListingAdd/rentalListingAdd.html',
	bindings: {
		listing: '<',
		user: '<',
		filters: '<',
		isLoggedIn: '<',
		isMobile: '<',
		errorMessages: '<',
		emailUsRpc: '<',
		buildingSearchRpc: '<',
		brokerSearchRpc: '<',
		unitSearchRpc: '<',
		is3rdPartyAccountExistRpc: '<',
		currentAddListingSteps: '<',
		companyPhone: '<',
		termsOfUseUrl: '<',
		privacyPolicyUrl: '<',
		forgotLinkUrl: '<',
		uploadRpc: '<',
		fbUser: '<',
		unitList: '<',
		missingImageSrc: '<',
		maxPrice: '<',
		minPrice: '<',
		maxSqft: '<',
		minSqft: '<',
		onFieldChange: '&',
		onSubmit: '&',
		onClearForm: '&',
		onSaveCurrentAddListingStep: '&',
		onUpdateUnitList: '&',
		activeStep: '<',
		steps: '<',
		onScrollToError: '&',
		uploadImageLimit: '<',
		onValidateEmail: '&'
	},
	controller: ['$http', '$timeout', 'PubSub', 'fbService', '$element', function($http, $timeout, PubSub, fbService, $element) {
		var ctrl = this;
		var fromFB = false;
		this.confirmed = false;
		this.furnished = false;
		this.addressHidden = false;
		this.isAgent = false;
		this.exclusiveToAgent = false;
		this.addListingSteps = {
			'generalInfo': 1,
			'images': 2,
			'submit': 3
		};

		this.activeAddListingSteps = this.currentAddListingSteps || this.addListingSteps.generalInfo;

		if (!this.isLoggedIn) {
			this.activeFormType = 'registration';
		}

		this.fieldChange = function(key) {
			this.onFieldChange({form: this.form, key: key});
		};

		this.clearForm = function() {
			this.onClearForm({form: this.form});
		};

		this.updateUnitList = function(list) {
			this.onUpdateUnitList({list: list});
		};

		this.fbLogin = function() {
			//if user is already logged in to FB
			if (!!this.fbUser.authResponse) {
				fbService.getInfo().then(function(userInfo) {
					if (userInfo) {
						ctrl.setFbUser(userInfo);
					}
				});
			} else {
				fbService.login().then(function() {
					return fbService.getLoginStatus();
				}).then(function(loginResponse) {
					if (!loginResponse.authResponse) {
						ctrl.fbError = true;
					} else {
						ctrl.fbUser.authResponse = loginResponse.authResponse;
					}
					return fbService.getInfo();
				}).then(function(userInfo) {
					if (userInfo) {
						ctrl.setFbUser(userInfo);
					}
				});
			}
		};

		this.googleLogin = function() {
			var googleProfile = googleAuth.getUser();
			if (googleProfile) {
				this.setGoogleUser(googleProfile);
			}
		};

		this.setGoogleUser = function(googleProfile) {
			fromFB = false;
			var profile = googleProfile.getBasicProfile();
			var googleUser = {
				userInfo: {
					name: profile.getName(),
					first_name: profile.getGivenName(),
					last_name: profile.getFamilyName(),
					email: profile.getEmail()
				},
				id_token: googleProfile.getAuthResponse().id_token
			};

			ctrl.onSubmit({form: ctrl.form, type: 'login', fromFB: fromFB, googleUser: googleUser})
		};

		this.setFbUser = function(userInfo) {
			this.fbUser.userInfo = userInfo;
			fromFB = true;
			$http({
				method: "post",
				url: this.is3rdPartyAccountExistRpc,
				data: {fb: {FBAppUserId: this.fbUser.userInfo.id}},
				headers: {"X-Requested-With": "XMLHttpRequest"}
			}).success(function(data) {
				if (data.status && data.is3rdPartyAccountExist) {
					// send rpc to log-in the user if the fb account is already registered in the database
					ctrl.onSubmit({form: ctrl.form, type: 'login', fromFB: fromFB, googleUser: null})
				} else {
					ctrl.fbUser.userInfo.emailProvidedByFB = false;

					ctrl.activeFormType = 'emailRequest';
				}
			}).error(function(data) {
				// error handling
			});
		};

		this.updateActiveForm = function(form) {
			this.activeFormType = form;
		};

		this.clickNext = function() {
			if (this.activeAddListingSteps !== this.addListingSteps.submit) {
				this.activeAddListingSteps += 1;

				this.onSaveCurrentAddListingStep({step: this.activeAddListingSteps})
				this.updateSubmitLabel();
			} else {
				var type = this.isLoggedIn ? 'publishListing' : this.activeFormType;

				this.onSubmit({form: this.form, type: type, fromFB: fromFB, googleUser: null});
			}
		};

		this.clickPrevious = function() {
			this.activeAddListingSteps -= 1;

			this.updateSubmitLabel();
		};

		this.updateSubmitLabel = function() {
			if (this.activeAddListingSteps < this.addListingSteps.submit) {
				this.submitLabel = 'Next';
			} else {
				this.submitLabel = 'Publish Listing';
			}
		};

		this.submitForm = function() {
			if (this.form.$valid) {
				// need a timeout to make the setPristine works when going to the next step.
				$timeout(function() {
					ctrl.clickNext();
				});
			} else if (ctrl.isMobile) {
				ctrl.onScrollToError();
			}
		};

		this.validateEmail = function(email, form) {
			this.onValidateEmail({email: email, form: form});
		};

		PubSub.subscribe('rental-listing-add-listing-show-login', function() {
			ctrl.updateActiveForm('login');
		});

		this.updateSubmitLabel();

		// TODO: REMOVE DEBUG
		// this.activeAddListingSteps = 3;
	}]
});
